<header class="reseller-nav">
  <div class="reseller-nav-brand">
    <img
      alt="MSP360"
      class="reseller-nav-logo"
      src="/images/Logo_main_tag.svg" />
    <span class="pl-2 fst-italic">{{ 'nav.tagline' | i18next }}</span>
  </div>

  <nav class="reseller-nav-links">
    @for (item of navItems; track item.route) {
      @let activeItem = isActiveMenuItem(item);
      <a
        class="reseller-nav-link"
        [class.active]="activeItem"
        [class.cursor-default]="activeItem"
        [routerLink]="item.route">
        {{ item.labelKey | i18next }}
      </a>
    }
  </nav>

  <div class="reseller-nav-user-container">
    <button
      class="fw-bold btn btn-light mr-2 reseller-nav-bell"
      data-e2e="notifications-bell-button"
      type="button"
      (click)="notificationsService.togglePanel()">
      <span class="fa fa-bell"></span>

      @if (notificationsService.unreadCount()) {
        <span
          class="border-radius-sm-important text-white reseller-nav-unread-circle"
          data-e2e="notifications-bell-counter"
          [ngClass]="'bg-' + notificationsService.badgeType()">
          {{ notificationsService.badgeText() }}
        </span>
      }
    </button>

    <div
      #accountDropdown="ngbDropdown"
      class="reseller-nav-user nav-item"
      display="dynamic"
      ngbDropdown
      placement="bottom-right bottom-left">
      <button
        class="fw-bold btn btn-light"
        id="dropdownUser"
        ngbDropdownToggle>
        <span
          class="nav-link_ico fa fa-user-circle-o"
          [class.text-danger]="auth.isSuperAdmin()"></span>
      </button>
      <ul
        aria-labelledby="dropdownUser"
        class="nav-submenu"
        ngbDropdownMenu
        placement="bottom-right">
        <li
          class="nav-item mbs-navbar_userinfo disabled"
          disabled="true">
          <div class="mbs-navbar_userinfo-item text-muted fw-bold">{{ 'nav.you' | i18next }}</div>
          <div class="mbs-navbar_userinfo-item text-muted">
            {{ auth.resellerEmail() }}
          </div>
          @if (auth.isSuperAdmin()) {
            <div class="mbs-navbar_userinfo-item text-muted">
              <span>{{ 'nav.superAdminPrefix' | i18next }}</span>
              {{ auth.userInfo()?.superAdminEmail }}
            </div>
          }
        </li>
        <li class="dropdown-divider"></li>
        <li
          class="nav-submenu-item"
          ngbDropdownItem>
          <button
            class="nav-submenu-link right-submenu"
            (click)="handleLogout()">
            <span class="nav-link_ico fa fa-sign-out"></span>
            {{ 'nav.logOut' | i18next }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</header>
